// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d10c1a1a","703":"3ca8f451"}[chunkId] + ".chunk.js";
};